import React from "react";
//import { WaveCanvas } from '../../components/WaveCanvas';

import './about.css';

import PageTitle from "../../components/PageTitle";



const About = () => {
	//const componentName = "About";

	const [isOpen, setIsOpen] = React.useState(false);

    const toggleimg = () => {
        setIsOpen(prev => !prev);
    };

	
	

	return(
	
		<div>
			

			<div className="profile-page-wrapper"></div>

			{/*<WaveCanvas />*/}
			

			<PageTitle title={"About"} />

			<div className="main">

				<h1 className="top-title">About</h1>

				{/* プロフィール */}
					<div className="frame">
						<h1 className="contents-title">Profile</h1>

						<div className="contents-flex">
							<img src="./src-about/my.png" className="face" onClick={toggleimg} alt="代理"/>

							<div className="About-Profile">
							{/*プロフィールの内容*/}
								<h3>Name : Adzuki.</h3>
								<h3>Gender : ♂</h3>
								<h3>{`Age : ${getAge(1999, 3, 24)}`}</h3>
								<h3>Birthday : 1999.03.24</h3>
							</div>

						</div>
						<hr/>

						<div className="More-Profile">
							<p>2015年頃に活動開始。「あずき」と読みます。</p>
							<p>主にやってるのは ゲーム制作/イラスト・漫画/動画編集等など。</p>
							<p>北海道旭川市出身。現在は都内在住。</p>

						</div>
					</div>

					<div className="frame">
						<h1 className="contents-title">History</h1>

						<div className="History-table">
							<table>
								<tbody>
								<tr>
									<th>Date</th> <th>Category</th> <th>Title</th> <th>Detail</th>
								</tr>
								<tr>
									<th>2026/4/19</th> <th>サークル参加</th> <th>関西けもケット11</th> <th>「たったひとつのしあわせ」頒布</th>
								</tr>
								<tr>
									<th>2026/3/1</th> <th>サークル参加</th> <th>ひぃふぅみぃ!!SUN</th> <th>「月とクローバーは交わらない」頒布</th>
								</tr>
								<tr>
									<th>2025/11/29</th> <th>サークル参加</th> <th>FLiP2025</th> <th>「躁のイマジア(1)」頒布</th>
								</tr>
								<tr>
									<th>2025/6/1</th> <th>サークル参加</th> <th>COMITIA152</th> <th>既刊のみ</th>
								</tr>
								<tr>
									<th>2025/5/18</th> <th>サークル参加</th> <th>関西けもケット10</th> <th>「シュガビタエブリデイズ その②」頒布</th>
								</tr>
								<tr>
									<th>2025/1/19</th> <th>サークル参加</th> <th>新春けもケット11</th> <th>「なにこれちろる」頒布</th>
								</tr>
								<tr>
									<th>2024/6/23</th> <th>サークル参加</th> <th>ひぃふぅみぃ!!つー</th> <th>既刊のみ</th>
								</tr>
								<tr>
									<th>2024/5/26</th> <th>サークル参加</th> <th>COMITIA148</th> <th>既刊のみ</th>
								</tr>
								<tr>
									<th>2024/5/19</th> <th>サークル参加</th> <th>関西けもケット9</th> <th>「シュガビタエブリデイズ その①」頒布</th>
								</tr>
								<tr>
									<th>2023/9/17</th> <th>サークル参加</th> <th>けもケット14</th> <th>「魔法少女はおやすみ！」頒布</th>
								</tr>
								<tr>
									<th>2023/5/6</th> <th>サークル参加</th> <th>けもケット13</th> <th>二次創作本 頒布</th>
								</tr>
								<tr>
									<th>2016/12/01</th> <th>プロコン入賞</th> <th>HSPプログラムコンテスト2016</th> <th>「Goodbyeborder」JBOYSOFT賞 受賞</th>
								</tr>
								</tbody>
							</table>
						</div>
						
						<p className="More-Profile">※ 売り子参加等は除く</p>
					</div>

					<div className="frame">
						<h1 className="contents-title">Guideline</h1>

						<div className="More-Profile">
							<p>Adzuki.のキャラクターを描いてくださる場合、</p>
							<p>ハッシュタグを付けて投稿していただければ、Adzuki.が徘徊しやすくなります。</p>
							<p>特に見て欲しい場合は、メンションを送ってくださると高確率で見ます。</p>
							
							<br/>
							<hr/>
							<br/>

							<p>■ 推奨ハッシュタグ</p>
							<p>#AdzukiFanArt</p>
							<p>■ 「シュガビタエブリデイズ」のFA向け</p>
							<p>#シュガビタFA</p>

							<br/>
							<hr/>
							<br/>

							<p>また、私自身はあまりこの表現をやってほしくない！という事は</p>
							<p>基本的にありませんが、常識の範囲内でお願い致します。</p>
							<br/>
							<p>＜例＞ NSFWな表現の場合はフィルタリングをかけて投稿 等…</p>
							<p>＜例2＞ 非営利目的で同人グッズ、同人誌を制作 等…</p>
							
							<br/>
							<hr/>
							<br/>

							<p>なるべくルールで縛りたくないんですが、やってほしくない事もあります。</p>
							<p>最低限これだけは守ってくれると幸いです。</p>
							<br/>
							<p>・転載、自作発言、(特に二次創作絵の)機械学習</p>
							<p>・無断で商業利用</p>
							<p>・政治/宗教等の活動への利用、誹謗中傷への利用</p>
							<br/>
							<p>その他、Adzuki.があまり良くないと思った場合、ミュートやブロックをする事があります。</p>
							<p>常識の範囲内でAdzuki.を喜ばして下さい。</p>
							

						</div>
					</div>
			</div>



			<div className="frame">
						<h1 className="contents-title">System</h1>

						<div className="More-Profile">
							<p>■  サーバー</p>
							<p>ドメイン:お名前.com</p>
							<p>データベース:お名前.com レンタルサーバー</p>
							<hr/>
							<p>■  フレームワーク</p>
							<p>使用言語:TypeScript</p>
							<p>サーバー/クライアント:React Router</p>
							<p>システムデータベース : Google Firebase</p>
							<hr/>
							<p>■  コンポーネント</p>
							<p>アイコン:react-icons</p>
							<p>タグ:react-select</p>
							<p>カレンダー:FullCalendar</p>
							<p>アニメーション:framer-motion</p>
							

						</div>
						
						
					</div>


		{/* ここはクリックしたら画像が拡大で表示されるエリア */}
			<div className={`modal-content ${isOpen ? "is-open" : ""}`} onClick={toggleimg}>
      			<img src="./src-about/popup.png" alt="拡大" className="popup" />
    		</div>

                    


			


		</div>
	);
};

//年齢計算
function getAge(year:number, month:number, day:number) {
  	// 今日の日付データを取得
  		const today = new Date();
  	// 生年月日の日付データを取得
  		const birthdate = new Date(year, month - 1, day);
  	// 今年の誕生日の日付データを取得
  		const currentYearBirthday = new Date(today.getFullYear(), birthdate.getMonth(), birthdate.getDate());
 	// 生まれた年と今年の差を計算
 	 let age = today.getFullYear() - birthdate.getFullYear();
  	// 今日の日付と今年の誕生日を比較
	if (today < currentYearBirthday) {
		// 今年誕生日を迎えていない場合、1を引く
		age--;
	}
	// 年齢の値を返す
	return age;
}




export default About;